/**
 * Viral video showcase: Swiper carousel, muted autoplay on active slide, 5s auto-advance.
 */
(function () {
  var AUTOPLAY_MS = 5000;
  var DESKTOP_MQ = '(min-width: 1026px)';
  var MIN_SLIDES_DESKTOP = 6;

  function pauseAllVideos(root) {
    root.querySelectorAll('.viral-video-showcase__video').forEach(function (video) {
      video.pause();
    });
  }

  function clearAutoplay(swiper) {
    if (swiper && swiper._viralAutoplayTimer) {
      clearTimeout(swiper._viralAutoplayTimer);
      swiper._viralAutoplayTimer = null;
    }
  }

  function scheduleAutoplay(swiper) {
    clearAutoplay(swiper);
    swiper._viralAutoplayTimer = setTimeout(function () {
      swiper._viralAutoplayTimer = null;
      swiper.slideNext();
    }, AUTOPLAY_MS);
  }

  function playActiveVideo(root, swiper) {
    pauseAllVideos(root);
    var activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;
    var video = activeSlide.querySelector('.viral-video-showcase__video');
    if (!video) return;
    video.muted = true;
    try {
      video.currentTime = 0;
    } catch (e) {}
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {});
    }
  }

  function updatePagination(root, swiper, slideCount) {
    var bullets = root.querySelectorAll('[data-viral-video-pagination-bullet]');
    if (!bullets.length || !swiper || slideCount < 1) return;
    var idx = swiper.realIndex % slideCount;
    bullets.forEach(function (bullet, i) {
      bullet.classList.toggle('is-active', i === idx);
    });
  }

  function restoreSlides(wrapper, originalSlides) {
    wrapper.innerHTML = '';
    originalSlides.forEach(function (slide) {
      wrapper.appendChild(slide);
    });
  }

  function cloneSlidesForDesktop(wrapper, originalSlides) {
    if (originalSlides.length >= MIN_SLIDES_DESKTOP) return;
    var times = Math.ceil(MIN_SLIDES_DESKTOP / originalSlides.length);
    for (var t = 1; t < times; t++) {
      originalSlides.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        wrapper.appendChild(clone);
      });
    }
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function initShowcase(root) {
    if (typeof Swiper === 'undefined') return;

    var swiperEl = root.querySelector('.viral-video-showcase__swiper');
    var prevBtn = root.querySelector('.viral-video-showcase__nav--prev');
    var nextBtn = root.querySelector('.viral-video-showcase__nav--next');
    var slideCount = parseInt(root.getAttribute('data-slide-count'), 10) || 0;
    var bullets = root.querySelectorAll('[data-viral-video-pagination-bullet]');

    if (!swiperEl || slideCount < 1) return;

    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    var originalSlides = Array.prototype.slice.call(wrapper.querySelectorAll('.swiper-slide'));
    var swiperInstance = null;
    var resizeTimer = null;

    bullets.forEach(function (bullet, index) {
      bullet.addEventListener('click', function () {
        if (!swiperInstance) return;
        if (swiperInstance.params.loop) {
          swiperInstance.slideToLoop(index);
        } else {
          swiperInstance.slideTo(index);
        }
      });
    });

    function destroySwiper() {
      if (swiperInstance) {
        clearAutoplay(swiperInstance);
        pauseAllVideos(root);
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
      restoreSlides(wrapper, originalSlides);
    }

    function mountSwiper() {
      destroySwiper();

      if (isDesktop()) {
        cloneSlidesForDesktop(wrapper, originalSlides);
      }

      var desktop = isDesktop();

      swiperInstance = new Swiper(swiperEl, {
        loop: slideCount > 1,
        slidesPerView: desktop ? 'auto' : 1,
        initialSlide: 0,
        centeredSlides: desktop,
        centerInsufficientSlides: desktop,
        spaceBetween: desktop ? 40 : 16,
        speed: 450,
        grabCursor: true,
        simulateTouch: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
          1026: {
            slidesPerView: 'auto',
            spaceBetween: 40,
            centeredSlides: true,
            centerInsufficientSlides: true,
          },
        },
        on: {
          afterInit: function (swiper) {
            playActiveVideo(root, swiper);
            scheduleAutoplay(swiper);
            updatePagination(root, swiper, slideCount);
          },
          slideChangeTransitionStart: function () {
            pauseAllVideos(root);
          },
          slideChangeTransitionEnd: function (swiper) {
            playActiveVideo(root, swiper);
            scheduleAutoplay(swiper);
            updatePagination(root, swiper, slideCount);
          },
          beforeDestroy: function () {
            clearAutoplay(swiperInstance);
            pauseAllVideos(root);
          },
        },
      });
    }

    function onBreakpointChange() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(mountSwiper, 150);
    }

    mountSwiper();
    window.matchMedia(DESKTOP_MQ).addEventListener('change', onBreakpointChange);
  }

  function initAll() {
    document.querySelectorAll('[data-viral-video-showcase]').forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
